export enum EventTypes {
  'Standard' = 0,
  'Specialty' = 1 ,
  'Private' = 2 ,
  'Demo' ,
}
